import styled from 'styled-components'
import { dark, light } from '@hotmart/space-lib/dist/styles/themes'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { limitLines } from 'src/styles'
import Icon from 'src/components/Icon'

export const ActionButton = styled.button`
  padding: 0.375rem !important;
`
ActionButton.displayName = 'ActionButton'

export const ButtonIcon = styled(Icon)`
  width: 0.8125rem;
  height: 0.8125rem;
`

ButtonIcon.displayName = 'ButtonIcon'

export const DropdownWrapper = styled.div<{ theme: string }>`
  background-color: ${({ theme }) =>
    theme === ThemeMode.DARK ? dark.colors.bgPrimary : light.colors.bgPrimary} !important;
  box-shadow: var(--box-shadow-sm);
  z-index: 1;
`

DropdownWrapper.displayName = 'DropdownWrapper'

export const CustomIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`

CustomIcon.displayName = 'CustomIcon'

export const DropdownItemText = styled.span`
  ${limitLines(1)}
  word-break: break-word;
  min-width: 6.25rem;
  max-width: 10rem;
`

DropdownItemText.displayName = 'DropdownItemText'
